import {gql} from "@apollo/client";
import filterDataGql, { executeQueryUtil } from '../utils/gqlUtil';
import apolloClient from "../apolloClient/ApolloClient";

const common = `
  id
  name
  design
  html
`

export const getLayoutQuery = (brandId, layoutId) => {
  var debug = `
    query {
      getLayout(brandId: "${brandId}", layoutId: "${layoutId}") {
        ${common}
      }
    }
  `
  console.log(debug);

  return gql`
    query {
      getLayout(brandId: "${brandId}", layoutId: "${layoutId}") {
        ${common}
      }
    }
  `;
}


export const getAllLayoutsByBrandIdQuery = (brandId) => {
  var debug = `
    query {
      getLayoutsByBrandId(brandId: "${brandId}") {
        ${common}
      }
    }
  `
  console.log(debug);

  return gql`
    query {
      getLayoutsByBrandId(brandId: "${brandId}") {
        ${common}
      }
    }
  `;
}

export const updateLayoutMutation = (brandId, data) => {
  delete data.updateDate;
  var dataString = filterDataGql(data, ["createdAt", "creationDate", "updateDate"]);

  var debug = `
    mutation {
      updateLayout(brandId: "${brandId}", data: ${dataString}) {
        ${common}
      }
    }
  `

  console.log(debug);

  return gql`mutation {
    updateLayout(brandId: "${brandId}", data: ${dataString}) {
        ${common}
    }
  }
  `;
}

export const createLayoutMutation = (brandId, data) => {
  delete data.updateDate;
  var dataString = filterDataGql(data, ["createdAt", "creationDate", "updateDate", "createdAt"],
      [] );

  var debug = `
    mutation {
      addLayout(brandId: "${brandId}", data: ${dataString}) {
        ${common}
      }
    }
  `

  console.log(debug);

  return gql`mutation {
      addLayout(brandId: "${brandId}", data: ${dataString}) {
        ${common}
      }
  }
  `;
}

export const bulkDeleteLayoutMutation = (brandId, ids) => {
  var idsString =  JSON.stringify(ids);

  var debug = `
    mutation {
      bulkDeleteLayout(brandId: "${brandId}", layoutsIds: ${idsString}) {
        ids
      }
    }
  `
  console.log(debug);

  return gql`
    mutation {
      bulkDeleteLayout(brandId: "${brandId}", layoutsIds: ${idsString}) {
        ids
      }
    }
  `;
}

export const deleteLayoutByBrandIdCache = async (brandId, ids) => {
  const query = getAllLayoutsByBrandIdQuery(brandId);
  const res = await executeQueryUtil(query);
  const newData = res.data.getLayoutsByBrandId.filter(item =>
    !ids.includes(item.id)
  )

  if (res) {
    await apolloClient.writeQuery({
      query: query,
      data: {
        getLayoutsByBrandId: [...newData]
      },
    });
  }
}



export const addDataLayoutByBrandIdToCache = async (brandId,datas) => {
  const query = getAllLayoutsByBrandIdQuery(brandId);
  const data = await executeQueryUtil(query);

  if (data) {
    await apolloClient.writeQuery({
      query: query,
      data: {
        getLayoutsByBrandId: [...data.data.getLayoutsByBrandId, ...datas]
      },
    });
  }
}

